import { render, staticRenderFns } from "./InfoWindow.vue?vue&type=template&id=60988c2a"
import script from "./InfoWindow.vue?vue&type=script&lang=js"
export * from "./InfoWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports